var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManSkateboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_35",
    "data-name": "Group 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 470,
    height: 539.746,
    viewBox: "0 0 470 539.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 470,
    height: 539.746,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M290.2,267.637s32.227-33.575,32.8-31.286c1.109,4.437,3.333,12.068,3.333,12.068l35.583-13.169s-12.373-60.088-18.773-67.127",
    transform: "translate(-92.095 -53.355)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M531.23,347.644c.627-6.953-22.4-2.986-22.4-2.986s21.467,13.3,22.4,2.986",
    transform: "translate(-161.481 -109.022)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M531.23,347.644c.627-6.953-22.4-2.986-22.4-2.986S530.3,357.957,531.23,347.644Z",
    transform: "translate(-161.481 -109.022)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M378.707,266.458l6.242,28.784s76.443,23.807,83.611,30.207,20.315,15.173,16.762,19.827c-2.286,2.995-27.258-15.732-27.258-15.732s25.93,17.663,22.271,22.783c-3.443,4.817-24.575-15.1-24.575-15.1s20.791,17.958,17.407,22.145c-3.243,4.012-20.479-15.233-20.479-15.233s7.936,9.728,6.4,12.288-19.455-15.616-24.063-17.919S352.534,314.7,352.534,314.7l-9.41-35.071Z",
    transform: "translate(-108.892 -84.562)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M378.707,266.458l6.242,28.784s76.443,23.807,83.611,30.207,20.315,15.173,16.762,19.827c-2.286,2.995-27.258-15.732-27.258-15.732s25.93,17.663,22.271,22.783c-3.443,4.817-24.575-15.1-24.575-15.1s20.791,17.958,17.407,22.145c-3.243,4.012-20.479-15.233-20.479-15.233s7.936,9.728,6.4,12.288-19.455-15.616-24.063-17.919S352.534,314.7,352.534,314.7l-9.41-35.071Z",
    transform: "translate(-108.892 -84.562)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x2: 4.603,
    y2: 19.419,
    transform: "translate(226.296 163.578)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M271.569,431.277l13.3,89.514-67.991,47.916-48.484-37.563,37.886-31.515s-41.4-76.822-39.352-118.463c37.529,27.887,104.643,50.112,104.643,50.112",
    transform: "translate(-52.952 -120.965)",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M271.569,431.277l13.3,89.514-67.991,47.916-48.484-37.563,37.886-31.515s-41.4-76.822-39.352-118.463C204.456,409.052,271.569,431.277,271.569,431.277Z",
    transform: "translate(-52.952 -120.965)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M242.9,442.624,260.1,529.87l-55.614,38.817",
    transform: "translate(-64.895 -140.469)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M150.38,596.623l63.442,49.15L182.1,660.451l-60.1-37.2Z",
    transform: "translate(-38.717 -189.342)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M118.016,640.087,93.937,660.335,159,710.806l-1.027-31.271,10.549-8.18Z",
    transform: "translate(-29.811 -203.135)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M118.016,640.087,93.937,660.335,159,710.806l-1.027-31.271,10.549-8.18Z",
    transform: "translate(-29.811 -203.135)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M166.961,355.508c47.434,36.863,163.007,68.748,163.007,68.748l24.189,126.092,62.336-15.536-7.168-131.547c-14.848-18.943-140.417-94.757-187.172-102.949Z",
    transform: "translate(-52.986 -95.307)",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M166.961,355.508c47.434,36.863,163.007,68.748,163.007,68.748l24.189,126.092,62.336-15.536-7.168-131.547c-14.848-18.943-140.417-94.757-187.172-102.949Z",
    transform: "translate(-52.986 -95.307)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M1.5,727.945s8.931,10.791,13.183,10.752c106.079-.983,338.562-2.348,444.785-3.925,3.514-.052,9.984-9.9,9.984-9.9",
    transform: "translate(-0.476 -230.043)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 15.525,
    cy: 15.525,
    r: 15.525,
    transform: "translate(125.616 507.671)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 15.525,
    cy: 15.525,
    r: 15.525,
    transform: "translate(368.218 506.306)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M431,659.908l79.528-19.822-1.707,29.038-71.678,11.6Z",
    transform: "translate(-136.78 -203.135)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M505.946,684.456V696l36.568,26.663-90.963.593-5.265-29.146Z",
    transform: "translate(-141.631 -217.216)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M505.946,684.456V696l36.568,26.663-90.963.593-5.265-29.146Z",
    transform: "translate(-141.631 -217.216)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M392.149,131.427c0,7.14-5.014,12.927-11.2,12.927s-11.2-5.787-11.2-12.927,5.014-12.927,11.2-12.927,11.2,5.787,11.2,12.927",
    transform: "translate(-117.342 -37.607)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 11.199,
    cy: 12.927,
    rx: 11.199,
    ry: 12.927,
    transform: "translate(252.408 80.893)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M233.172,219.994s51.225-31.408,102.45-26.032",
    transform: "translate(-73.998 -61.359)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M241.062,228.262s41.365-32.236,98.087-24.673",
    transform: "translate(-76.502 -64.246)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M269.751,277.582s26.254,2.559,43.005-1.708",
    transform: "translate(-85.607 -87.55)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M260.751,286.265s26.581,3.034,45.565-2.391",
    transform: "translate(-82.751 -90.089)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 44.713,
    height: 34.132,
    transform: "translate(99.304 138.561) rotate(-55.699)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 44.713,
    height: 34.132,
    transform: "translate(99.304 138.561) rotate(-55.699)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 44.713,
    height: 13.056,
    transform: "matrix(0.564, -0.826, 0.826, 0.564, 127.5, 157.795)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 44.713,
    height: 13.056,
    transform: "matrix(0.564, -0.826, 0.826, 0.564, 127.5, 157.795)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 37.056,
    height: 20.862,
    transform: "matrix(0.564, -0.826, 0.826, 0.564, 99.304, 138.561)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 37.056,
    height: 20.862,
    transform: "matrix(0.564, -0.826, 0.826, 0.564, 99.304, 138.561)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M347.381,144.194c3.262-.92,1.365-3.5,5.888-11.008,4.609-7.649,23.139-13.781,23.125-19.37-.032-12.226-27.889-31.4-55.465-14.336-3.922,2.427-15.882,1.812-17.045,7.061-1.855,8.384,4.975,5.415,7.168,11.328,3.307,8.917,12.864,13.183,18.069,15.572,6.007,2.757,7.756,13.714,18.261,10.752",
    transform: "translate(-96.339 -29.425)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M347.381,144.194c3.262-.92,1.365-3.5,5.888-11.008,4.609-7.649,23.139-13.781,23.125-19.37-.032-12.226-27.889-31.4-55.465-14.336-3.922,2.427-15.882,1.812-17.045,7.061-1.855,8.384,4.975,5.415,7.168,11.328,3.307,8.917,12.864,13.183,18.069,15.572C335.126,136.2,336.876,147.156,347.381,144.194Z",
    transform: "translate(-96.339 -29.425)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 45.823,
    height: 37.119,
    transform: "translate(87.037 41.726)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M127.5,61.124l23.039,16.554,22.783-16.554Z",
    transform: "translate(-40.463 -19.398)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 52.734,
    height: 45.567,
    transform: "translate(1.024 19.711)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 52.734,
    height: 45.567,
    transform: "translate(1.024 19.711)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 26.367,
    height: 15.743,
    transform: "translate(1.024 28.159)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 26.367,
    height: 15.743,
    transform: "translate(1.024 28.159)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    x2: 17.066,
    transform: "translate(1.621 51.71)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x2: 9.301,
    transform: "translate(1.621 57.086)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 15.189,
    height: 44.884,
    transform: "translate(38.569 19.711)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 15.189,
    height: 44.884,
    transform: "translate(38.569 19.711)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 56.197,
    height: 65.037,
    transform: "matrix(0.547, -0.837, 0.837, 0.547, 336.677, 175.717)",
    fill: "#c0c1c0",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 56.197,
    height: 65.037,
    transform: "matrix(0.547, -0.837, 0.837, 0.547, 336.677, 175.717)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 19.416,
    height: 32.518,
    transform: "translate(351.098 153.649) rotate(-56.834)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 19.416,
    height: 32.518,
    transform: "translate(351.098 153.649) rotate(-56.834)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x2: 18.235,
    y2: 11.917,
    transform: "translate(345.83 161.71)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 10.219,
    y2: 6.678,
    transform: "translate(342.203 167.26)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 56.197,
    height: 18.733,
    transform: "translate(375.438 201.048) rotate(-56.835)",
    fill: "#231f20",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 56.197,
    height: 18.733,
    transform: "translate(375.438 201.048) rotate(-56.835)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 114.957,
    height: 121.622,
    transform: "translate(20.073 182.103) rotate(-45)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 114.957,
    height: 121.622,
    transform: "translate(20.073 182.103) rotate(-45)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 114.957,
    height: 37.067,
    transform: "translate(79.863 241.893) rotate(-45)",
    fill: "#565656",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 114.957,
    height: 37.067,
    transform: "translate(79.863 241.893) rotate(-45)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M150.72,213.4,91.081,153.906l39.183-6.22,59.79,59.789Z",
    transform: "translate(-28.905 -46.869)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M150.72,213.4,91.081,153.906l39.183-6.22,59.79,59.789Z",
    transform: "translate(-28.905 -46.869)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M90.761,103.124s14.328,9.472,17.656,15.359",
    transform: "translate(-28.804 -32.727)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M168.941,130.515s-2.354,8.478-2.816,11.721",
    transform: "translate(-52.721 -41.42)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M247.736,57.375s-22.1,20.065-26.111,27.647",
    transform: "translate(-70.334 -18.208)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 44.798,
    height: 54.142,
    transform: "matrix(0.842, -0.54, 0.54, 0.842, 146.924, 86.076)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 44.798,
    height: 54.142,
    transform: "matrix(0.842, -0.54, 0.54, 0.842, 146.924, 86.076)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 17.28,
    height: 32.111,
    transform: "matrix(0.842, -0.54, 0.54, 0.842, 169.732, 85.478)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 17.28,
    height: 32.111,
    transform: "matrix(0.842, -0.54, 0.54, 0.842, 169.732, 85.478)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 7.443,
    y2: 11.604,
    transform: "translate(163.483 89.485)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 7.443,
    y2: 11.604,
    transform: "translate(163.483 89.485)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 5.923,
    y2: 9.234,
    transform: "translate(159.173 92.249)",
    fill: "#dadada",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 5.923,
    y2: 9.234,
    transform: "translate(159.173 92.249)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M305.424,14.888S287.377,4.52,280.592,11.3,302.16,32.36,296.464,38.055s-29.6-11.647-32.208-18.559",
    transform: "translate(-83.863 -2.857)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x1: 29.439,
    y2: 29.439,
    transform: "translate(188.153 1.024)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    x1: 32.255,
    y2: 32.255,
    transform: "translate(190.841 3.712)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M342.722,391.961l85.894,52.159,14.132,102.537",
    transform: "translate(-108.765 -124.391)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManSkateboard);
export default __webpack_public_path__ + "static/media/man_skateboard.246e1acad7703136c26e0fbc1d836ef7.svg";
export { ForwardRef as ReactComponent };